import  { useEffect } from "react";
import { useMap, useMapEvents } from "react-leaflet";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import socket from "../../assets/socketConnection";
import {
  fetchCenterOfMapAddressAsync,
  fetchCenterOfMapAddressStart,
  setCenterOfMap,
  setSuggestionsShow,
  toggleMapOverlayLeftShow,
} from "../../redux/map/map.actions";
import {
  selectMapLeftOverlayShow,
  selectMapSuggestionsShow,
} from "../../redux/map/map.selectors";
// import { setNewRequestSetSelectedDistrict } from "../../redux/newRequest/newRequest.actions";
import {
  // selectNewRequestCities,
  selectNewRequestSelectedCity,
  selectNewRequestSelectedDistrict,
  selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel,
} from "../../redux/newRequest/newRequest.selectors";

const GetMapCenter = ({
  getCenter,
  setGetCenter,

  toggleMapOverlayLeftShow,
  selectMapLeftOverlayShow,

  setCenterOfMap,
  fetchCenterOfMapAddressAsync,
  fetchCenterOfMapAddressStart,

  selectMapSuggestionsShow,
  setSuggestionsShow,
}) => {
  const map2 = useMap();

  // map2.addEventListener("click", () => alert("hi"));

  useEffect(() => {
    centerLocation(map2, setCenterOfMap, fetchCenterOfMapAddressAsync);

    // return () => {
    //     cleanup
    // }
  }, []);

  if (getCenter) {
    setGetCenter(false);
    map2.locate();
  }

  // console.log(selectNewRequestSelectedProvince);
  // debugger;

  // debugger;

  const map = useMapEvents({
    movestart() {
      fetchCenterOfMapAddressStart();
      if (selectMapLeftOverlayShow) toggleMapOverlayLeftShow(false);
      // debugger;
      // if (selectMapSuggestionsShow)
      setSuggestionsShow(false);
    },

    moveend() {
      centerLocation(map, setCenterOfMap, fetchCenterOfMapAddressAsync);
    },

    // click() {
    //   map.locate();
    // },

    locationfound(e) {
      //   setPosition(e.latlng)
      map.flyTo(e.latlng, 15);
      // debugger;
    },
  });

  return null;
};

const centerLocation = (map, setCenterOfMap, fetchCenterOfMapAddressAsync) => {
  const x = map.getCenter();
  setCenterOfMap(x);
  fetchCenterOfMapAddressAsync(socket);
  //   debugger;

  //   alert("asdf");

  return x;
};

const mapDispatchToProps = (dispatch) => ({
  setCenterOfMap: (x) => dispatch(setCenterOfMap(x)),

  fetchCenterOfMapAddressAsync: (x) =>
    dispatch(fetchCenterOfMapAddressAsync(x)),
  fetchCenterOfMapAddressStart: () => dispatch(fetchCenterOfMapAddressStart()),

  toggleMapOverlayLeftShow: (x) => dispatch(toggleMapOverlayLeftShow(x)),

  setSuggestionsShow: (x) => dispatch(setSuggestionsShow(x)),
});

const mapStateToProps = createStructuredSelector({
  selectMapLeftOverlayShow: selectMapLeftOverlayShow,
  selectNewRequestSelectedProvince: selectNewRequestSelectedProvince,
  selectNewRequestSelectionLevel: selectNewRequestSelectionLevel,

  selectNewRequestSelectedCity: selectNewRequestSelectedCity,
  selectNewRequestSelectedDistrict: selectNewRequestSelectedDistrict,

  selectMapSuggestionsShow: selectMapSuggestionsShow,
});

export default connect(mapStateToProps, mapDispatchToProps)(GetMapCenter);
